import PropTypes from 'prop-types';
export const formLabelPropTypes = {
  /**
   * Children as node
   */
  children: PropTypes.node,
  /**
   * Additional classname
   */
  classname: PropTypes.string
};